export default function videoShorts() {
  const sections = document.querySelectorAll('.roc-video-shorts');
  if (!sections.length) return;

  sections.forEach(section => {
    const slides = section.querySelectorAll('.roc-video-shorts__slide');
    const slider = section.querySelector('.roc-video-shorts__slider');
    const cards = section.querySelectorAll('.roc-video-shorts__card');
    const prev = section.querySelector('.is-prev');
    const next = section.querySelector('.is-next');

    let isVideoActive = false;
    let current = 0;

    // ----------------------------
    // ARROW VISIBILITY (SLICK-LIKE)
    // ----------------------------
    const updateArrows = () => {
      if (!slider || !prev || !next) return;

      const totalWidth = slider.scrollWidth;
      const visibleWidth = slider.clientWidth;

      if (totalWidth <= visibleWidth + 5) {
        prev.style.display = 'none';
        next.style.display = 'none';
      } else {
        prev.style.display = '';
        next.style.display = '';
      }
    };

    // ----------------------------
    // CENTERING LOGIC (SMOOTH)
    // ----------------------------
    const scrollToCenter = (index) => {
      const target = slides[index];
      if (!target || !slider) return;

      const targetLeft = target.offsetLeft;
      const targetWidth = target.offsetWidth;
      const sliderWidth = slider.clientWidth;

      const scrollTarget = targetLeft - (sliderWidth / 2) + (targetWidth / 2);

      slider.scrollTo({
        left: scrollTarget,
        behavior: 'smooth',
      });
    };

    // ----------------------------
    // ACTIVE STATE
    // ----------------------------
    const setActive = (index) => {
      if (index < 0 || index >= slides.length) return;
      if (index === current) return;

      slides.forEach(s => s.classList.remove('is-active'));
      cards.forEach(c => c.classList.remove('is-active'));

      const activeSlide = slides[index];
      const activeCard = cards[index];

      if (!activeSlide || !activeCard) return;

      activeSlide.classList.add('is-active');
      activeCard.classList.add('is-active');

      current = index;

      // first pass (immediate)
      scrollToCenter(index);

      // second pass (after flex expansion settles)
      setTimeout(() => {
        scrollToCenter(index);
      }, 300); // match your CSS transition (~0.45s → use 250–350)
    };

    // ----------------------------
    // STOP VIDEOS
    // ----------------------------
    const stopVideos = () => {
      section.querySelectorAll('.roc-video-shorts__card.is-playing').forEach(card => {

        const container = card.querySelector('.roc-video-shorts__video-container');

        // HTML5 video
        container?.querySelectorAll('video').forEach(v => {
          v.pause();
          v.currentTime = 0;
        });

        // 🔥 YOUTUBE / IFRAME HARD RESET
        container?.querySelectorAll('iframe').forEach(i => {
          const src = i.src;
          i.src = '';       // unload
          i.src = src;      // reload thumbnail state
        });

        // remove ALL states
        card.classList.remove('is-playing');
        card.classList.remove('is-active');
      });

      isVideoActive = false;
      section.classList.remove('is-video-active');
    };

    // ----------------------------
    // ARROWS
    // ----------------------------
    let isAnimating = false;

    const goTo = (index) => {
      if (isAnimating) return;

      isAnimating = true;

      // 🔥 ALWAYS STOP VIDEO FIRST
      stopVideos();

      setActive(index);

      setTimeout(() => {
        isAnimating = false;
      }, 400);
    };

    next?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(Math.min(current + 1, cards.length - 1));
    });

    prev?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(Math.max(current - 1, 0));
    });


    let scrollTimer = null;

    slider?.addEventListener('scroll', () => {
      // user is scrolling → kill any playing video immediately
      if (isVideoActive) {
        stopVideos();
      }

      // debounce scroll end
      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        // find closest slide to center
        const sliderCenter = slider.scrollLeft + (slider.clientWidth / 2);

        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, i) => {
          const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
          const distance = Math.abs(sliderCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });

        setActive(closestIndex);

      }, 120); // tweak 100–150ms
    });

    // ----------------------------
    // CARD CLICK (ACTIVATE)
    // ----------------------------
    cards.forEach((card, i) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.roc-video-shorts__play')) return;

        // 🔥 stop any playing video when switching cards
        stopVideos();

        if (isVideoActive) return;

        setActive(i);
      });
    });

    // ----------------------------
    // PLAY VIDEO
    // ----------------------------
    section.addEventListener('click', (e) => {
      const trigger = e.target.closest('.roc-video-shorts__play');
      if (!trigger) return;

      const card = trigger.closest('.roc-video-shorts__card');
      if (!card) return;

      if (!card.classList.contains('has-video')) return;
      if (card.classList.contains('is-playing')) return;

      stopVideos();

      isVideoActive = true;
      section.classList.add('is-video-active');

      slides.forEach(s => s.classList.remove('is-active'));
      cards.forEach(c => c.classList.remove('is-active'));

      const index = Array.from(cards).indexOf(card);

      if (slides[index]) {
        slides[index].classList.add('is-active');
      }

      card.classList.add('is-active');
      card.classList.add('is-playing');

      const iframe = card.querySelector('iframe');

      if (iframe && iframe.src.includes('youtube')) {

        const onPlayerReady = () => {
          const player = new YT.Player(iframe, {
            events: {
              onStateChange: (event) => {
                if (
                  event.data === YT.PlayerState.PAUSED ||
                  event.data === YT.PlayerState.ENDED
                ) {
                  setTimeout(() => {
                    resetCard(card);
                  }, 50);
                }
              }
            }
          });
        };

        if (window.YT && window.YT.Player) {
          onPlayerReady();
        } else {
          window.onYouTubeIframeAPIReady = onPlayerReady;
        }
      }

      scrollToCenter(index);

      setTimeout(() => {
        scrollToCenter(index);
      }, 300);
    });

    // ----------------------------
    // VIDEO RESET
    // ----------------------------
    const resetCard = (card) => {
      if (!card) return;

      const container = card.querySelector('.roc-video-shorts__video-container');

      // 🔥 HARD RESET ALL VIDEOS
      container?.querySelectorAll('video').forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      container?.querySelectorAll('iframe').forEach(i => {
        const src = i.src;
        i.src = '';       // force unload
        i.src = src;      // reload (thumbnail state)
      });

      // remove states
      card.classList.remove('is-playing');
      card.classList.remove('is-active');

      isVideoActive = false;
      section.classList.remove('is-video-active');
    };

    section.addEventListener('pause', (e) => {
      if (e.target.tagName !== 'VIDEO') return;
      resetCard(e.target.closest('.roc-video-shorts__card'));
      setTimeout(() => {
        resetCard(e.target.closest('.roc-video-shorts__card'));
      }, 50);
    }, true);

    section.addEventListener('ended', (e) => {
      if (e.target.tagName !== 'VIDEO') return;
      resetCard(e.target.closest('.roc-video-shorts__card'));
      setTimeout(() => {
        resetCard(e.target.closest('.roc-video-shorts__card'));
      }, 50);
    }, true);

    // ----------------------------
    // CLICK OUTSIDE
    // ----------------------------
    document.addEventListener('click', (e) => {
      if (e.target.closest('.roc-video-shorts__card')) return;
      stopVideos();
    });

    // ----------------------------
    // INIT
    // ----------------------------
    current = 0;
    updateArrows();
    window.addEventListener('resize', updateArrows);
  });
}
